export default __webpack_public_path__ + "static/media/AvenirNextLTPro-Bold.e6edb302.woff";